import { io } from "socket.io-client";

const socket = io("https://live.claimsmitra.com", {
  path: "/socket.io",
});

export default socket;